import React from "react";
import { css } from "@emotion/core";
import { Tablet, Desktop } from "../../constants/responsive";
import HK from "../../svgs/fee/HK.svg";
import US from "../../svgs/fee/US.svg";
import CN from "../../svgs/fee/CN.svg";
import { useIntl } from "gatsby-plugin-intl";

// 【交易佣金收费明细】卡片
const Card = ({ title, icon, content }) => {
  const intl = useIntl();

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        overflow: hidden;
        text-align: left;
        width: 80%;
        max-width: 400px;
        border-radius: 8px;
        border: 1px solid #e6e7eb;
        box-shadow: 2px 2px 10px 1px #c7c7c733;
        padding-bottom: 24px;

        ${Tablet} {
          gap: 22px;
          width: 30%;
          max-width: 380px;
        }
        ${Desktop} {
          gap: 22px;
          width: 32%;
        }
      `}
    >
      <div
        css={css`
          background: #ee2f79;
          width: 100%;
          height: 10px;
        `}
      />
      <div
        css={css`
          display: flex;
          align-items: center;
          height: 32px;
          font-size: 26px;
          font-weight: 700;
          gap: 4px;
          width: 100%;
          text-align: left;
          padding: 0 24px;
        `}
      >
        {icon}
        <span>{title}</span>
      </div>
      <div
        css={css`
          font-size: 18px;
          font-weight: 500;
          color: #69758a;
          padding: 0 24px;
        `}
      >
        {intl.formatMessage({
          id: "fee.trade-commission-fee-details.transaction-fee-structure",
        })}
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          width: 100%;
          padding: 0 24px;
          font-weight: 500;
        `}
      >
        <div
          css={css`
            font-size: 18px;
            color: #69758a;
          `}
        >
          {intl.formatMessage({
            id: "fee.trade-commission-fee-details.commission",
          })}
        </div>
        <div
          css={css`
            font-size: 22px;
            color: #333;
            white-space: pre-line;
          `}
        >
          {content}
        </div>
      </div>
    </div>
  );
};

const FeeDetailCards = () => {
  const intl = useIntl();
  return (
    <div
      css={css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        width: 100%;
        justify-content: flex-start;
      `}
    >
      <Card
        title={intl.formatMessage({
          id: "fee.trade-commission-fee-details.HK Stock",
        })}
        icon={<HK />}
        content={intl.formatMessage({
          id: "fee.trade-commission-fee-details.HKContent",
        })}
      />
      <Card
        title={intl.formatMessage({
          id: "fee.trade-commission-fee-details.US Stock",
        })}
        icon={<US />}
        content={intl.formatMessage({
          id: "fee.trade-commission-fee-details.USContent",
        })}
      />
      <Card
        title={intl.formatMessage({
          id: "fee.trade-commission-fee-details.Northbound Stocks",
        })}
        icon={<CN />}
        content={intl.formatMessage({
          id: "fee.trade-commission-fee-details.CNContent",
        })}
      />
    </div>
  );
};

export default FeeDetailCards;
